module.exports = __webpack_public_path__ + "static/media/2-3.eba4c902.mp3";